import alloyAnalytics from '@telus/alloy-analytics'
import {
  getOrderType,
  getProducts,
  getProductName,
  getProductData,
  getProductsByType,
  getValidationErrors,
  getMobilityPromoCode
} from './helpers'

import alloyEvents from './events'

const initAlloyAnalytics = () => {
  alloyAnalytics.config({
    defaultValues: {
      webPageDetails: {
        lob: 'digital_commerce',
        siteGenerator: 'dc-ui-cart'
      }
    },
    formatters: {
      orderType: getOrderType,
      cartProducts: getProducts,
      product: getProductData,
      productName: getProductName,
      productsByType: getProductsByType,
      validationErrors: getValidationErrors,
      mobilityPromoCode: getMobilityPromoCode
    }
  })
}

export default initAlloyAnalytics
export { alloyEvents }
